<template>
  <b-row>
    <b-col md="2">
      <filters-card
          :start.sync="start"
          :end.sync="end"
          :employees.sync="employees"
      />
    </b-col>

    <b-col md="10">
      <expenses-types-card
          :start="start"
          :end="end"
          :employees="employees"
      />

      <articles-card
          :start="start"
          :end="end"
          :employees="employees"
      />

    </b-col>

  </b-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import moment from 'moment'
import FiltersCard from './components/_filters'
import useAPI from '../../../utils/useAPI'
import ArticlesCard from '../../../components/indicators/articles/ArticlesCard'
import ExpensesTypesCard from '../../../components/indicators/expenses/ExpensesTypesCard'

export default {
  components: {
    FiltersCard,
    ArticlesCard,
    ExpensesTypesCard
  },
  props: {},
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const currentYear = parseInt(new Date().getFullYear())
    const currentMonth = parseInt(new Date().getMonth())
    const start = ref(moment((currentMonth < 7 ? (currentYear - 1) : currentYear) + '-07-01').format('YYYY-MM-DD'))
    const end = ref(moment((currentMonth < 7 ? currentYear : (currentYear + 1)) + '-06-30').format('YYYY-MM-DD'))
    const employees = ref([])

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    // const {
    //   fetchUsers,
    //   fetchOrders,
    //   fetchIncomingInvoices,
    //   fetchEvents,
    //   fetchSalaries,
    //   fetchSocialSecurityContributions
    // } = useAPI()
    const { fetchAutocompleteUsers } = useAPI()

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    fetchAutocompleteUsers({
      searchCriteria: [
        {
          "column_name": "invitationCode",
          "comparator": "notNull"
        },
        {
          "column_name": "roles",
          "comparator": "!=",
          "search_text": "[]"
        },
        {
          "column_name": "password",
          "comparator": "notNull"
        }
      ]
    })
    // fetchUsers()
    // fetchOrders()
    // fetchIncomingInvoices()
    // fetchEvents()
    // fetchSalaries()
    // fetchSocialSecurityContributions()

    return {
      // Components

      // Data
      start,
      end,
      employees,

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>